import React from "react";
import DOMPurify from "dompurify";

const FormSubmitted = props => {
  const { resultType, introMessage, variant } = props;
  const hideSignIn = variant === "stewartcom";
  // For StewartCom, submissions are auto-approved on submit. Both "success"
  // and "pending" show the "Stewart Account Created" screen with a Sign In
  // button that goes to the regular B2C sign-in page.
  const isStewartComSuccessLike =
    variant === "stewartcom" &&
    (resultType === "success" || resultType === "pending");
  const isStewartComActive =
    variant === "stewartcom" && resultType === "active";
  const effectiveResultType = isStewartComSuccessLike ? "success" : resultType;
  const effectiveIntroMessage = isStewartComActive
    ? window.regFormModel.activeMsg || introMessage
    : isStewartComSuccessLike && resultType !== "success"
      ? window.regFormModel.confirmMsg || introMessage
      : introMessage;
  const sanitizedIntroMessage = () => ({
    __html: DOMPurify.sanitize(effectiveIntroMessage),
  });
  const sanitizedUtilityMessage = () => ({
    __html: DOMPurify.sanitize(window.regFormModel.utilityMsg),
  });

  return (
    <div className="request-account-form__success-screen">
      {effectiveResultType === "success" && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="94"
          height="94"
          fill="none"
        >
          <path
            fill="#00875A"
            d="M68.09 26.04 37.33 56.79 20.58 40.1 14 46.67 37.33 70l37.34-37.33-6.58-6.63ZM46.67 0A46.68 46.68 0 0 0 0 46.67a46.68 46.68 0 0 0 46.67 46.66 46.68 46.68 0 0 0 46.66-46.66A46.68 46.68 0 0 0 46.67 0Zm0 84A37.32 37.32 0 0 1 9.33 46.67 37.32 37.32 0 0 1 46.67 9.33 37.32 37.32 0 0 1 84 46.67 37.32 37.32 0 0 1 46.67 84Z"
          />
        </svg>
      )}
      {effectiveResultType !== "success" && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="94"
          height="94"
          fill="none"
        >
          <path
            fill="#E00000"
            d="M42 60.67h9.33V70H42v-9.33Zm0-37.34h9.33v28H42v-28ZM46.62 0A46.64 46.64 0 0 0 0 46.67a46.64 46.64 0 0 0 46.62 46.66 46.7 46.7 0 0 0 46.71-46.66A46.7 46.7 0 0 0 46.62 0Zm.05 84A37.32 37.32 0 0 1 9.33 46.67 37.32 37.32 0 0 1 46.67 9.33 37.32 37.32 0 0 1 84 46.67 37.32 37.32 0 0 1 46.67 84Z"
          />
        </svg>
      )}
      <div
        className="request-account-form__intro-message"
        dangerouslySetInnerHTML={sanitizedIntroMessage()}
      ></div>
      {isStewartComSuccessLike ? (
        <form
          name="form"
          action={window.regFormModel.signInLink}
          method="post"
        >
          <button className="btn btn--primary" type="submit">
            Sign In
          </button>
        </form>
      ) : (
        <button
          className="btn btn--primary"
          onClick={() => window.location.reload()}
          type="button"
        >
          Return to Request Page
        </button>
      )}
      {effectiveResultType === "success" && !hideSignIn && (
        <p>
          <span dangerouslySetInnerHTML={sanitizedUtilityMessage()}></span>{" "}
          <form
            name="form"
            action={window.regFormModel.signInLink}
            method="post"
            className="request-account-form__sign-in-link"
          >
            <button type="submit">Sign In</button>
          </form>
        </p>
      )}
    </div>
  );
};
export default FormSubmitted;
